import { useMemo } from "react";

export const useTripleWhale = () =>
  useMemo(() => {
    //@ts-ignore
    const triplePixel =
      typeof window !== "undefined" && window.TriplePixel
        ? window.TriplePixel
        : () => {};

    const trackAddToCart = (item: string, q: number) => {
      triplePixel("AddToCart", { item, q });
    };

    const trackVisitorContact = (email: string) => {
      triplePixel("Contact", { email });
    };

    const trackPageLoad = (type: string) => {
      triplePixel("PageLoad", { type });
    };

    return { trackAddToCart, trackVisitorContact, trackPageLoad };
  }, []);
